/**
 * "Versão nova disponível", em cima de qualquer tela.
 *
 * Aparece quando o servidor publica uma versão e o aparelho já a baixou: ela
 * fica esperando o momento de entrar. Quem escolhe o momento é o operador —
 * atualizar no meio de uma leitura seria trocar a tela com a fila andando.
 *
 * Atualizar aqui não perde nada: o banco das validações e a sessão não passam
 * pelo service worker (ver src/web/atualizacao.ts).
 *
 * No mãos livres o aviso se cala: ali o operador está olhando a fila, e a
 * faixa cobriria justamente a área do desfecho. Ele volta assim que o modo
 * for desligado.
 */

import React from 'react';
import {Pressable, Text, View} from 'react-native';
import {RefreshCw} from 'lucide-react-native';
import {useSafeAreaInsets} from 'react-native-safe-area-context';

import {useAtualizacao} from '../web/atualizacao';
import {txt, useIdioma} from './idioma';
import {useMaosLivresEmUso} from './maosLivres';
import {fontes, useTema} from './tema';

export function AvisoAtualizacao() {
  const t = useTema();
  useIdioma();
  const {temVersaoNova, atualizar, adiar} = useAtualizacao();
  const maosLivres = useMaosLivresEmUso();
  // A faixa é a primeira coisa da página: no iPhone, sem o recuo, ela ficava
  // embaixo do relógio e da bateria, com o "Atualizar" coberto.
  const insets = useSafeAreaInsets();

  if (!temVersaoNova || maosLivres) {
    return null;
  }

  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        paddingHorizontal: 14,
        paddingTop: insets.top + 10,
        paddingBottom: 10,
        backgroundColor: t.superficieAlta,
        borderBottomWidth: 2,
        borderBottomColor: t.primaria,
      }}>
      <RefreshCw size={18} color={t.primaria} strokeWidth={2.4} />

      <View style={{flex: 1}}>
        <Text style={{color: t.texto, fontSize: 14, fontFamily: fontes.negrito}}>
          {txt('Versão nova disponível')}
        </Text>
        <Text style={{color: t.textoFraco, fontSize: 12, fontFamily: fontes.regular}}>
          {txt('Atualizar não apaga validação nem desconecta')}
        </Text>
      </View>

      <Pressable
        onPress={adiar}
        hitSlop={8}
        style={{paddingHorizontal: 10, paddingVertical: 8}}>
        <Text style={{color: t.textoFraco, fontSize: 13, fontFamily: fontes.semi}}>
          {txt('Depois')}
        </Text>
      </Pressable>

      <Pressable
        onPress={atualizar}
        style={{
          paddingHorizontal: 16,
          paddingVertical: 10,
          borderRadius: 12,
          backgroundColor: t.primaria,
        }}>
        <Text style={{color: t.tintaPrimaria, fontSize: 14, fontFamily: fontes.negrito}}>
          {txt('Atualizar')}
        </Text>
      </Pressable>
    </View>
  );
}
